module.exports = __webpack_public_path__ + "static/media/easycoach_logo.1b8bf384.jpeg";